import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import store from "@/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAMap from "vue-amap";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font-icon/iconfont.css";
import "@mdi/font/css/materialdesignicons.css"
import 'material-design-icons-iconfont/dist/material-design-icons.css'


import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import JsonViewer from 'vue-json-viewer';
Vue.use(JsonViewer);

import vueJsonEditor from 'vue-json-editor'
Vue.use(vueJsonEditor);


Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: "f015b1af6fd76b0ae88957f846d169a7",
    plugin: [
        "Geolocation",
        "Geocoder",
        "AMap.Autocomplete",
        "AMap.PlaceSearch",
        "AMap.Scale",
        "AMap.OverView",
        "AMap.ToolBar",
        "AMap.MapType",
        "AMap.PolyEditor",
        "AMap.CircleEditor",
        "AMap.Geocoder"
    ],
    // 默认高德 sdk 版本为 1.4.4
});

Vue.config.productionTip = false;

// 在开发环境development显示console.log,生产环境production屏蔽 
(function shieldConsole() {
	console.log("当前环境：" + process.env.NODE_ENV)
    if (process.env.NODE_ENV == "production") {
        Reflect.ownKeys(console).map(key => {
            if (typeof console[key] == "function") {
                console[key] = () => {};
            }
        });
    }
    return;
})();

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount("#app");

router.beforeEach((to, _from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title + "-美森汽车充电管理平台";
    }
    next();
});